export default __webpack_public_path__ + "static/media/google-calendarIcon.f7504262.svg";